export default __webpack_public_path__ + "static/media/varvara.74f90764.jp2";